







import PluginComponent    from "@/components/PluginComponent.vue";
import { Component, Vue } from "vue-property-decorator";

@Component({
      name      : "PluginTest",
      components: {PluginComponent}
  })
  export default class PluginTest extends Vue {
  }
